import { stripTypename } from "@apollo/client/utilities"

import { request } from "shared/api/request"
import { generateUUID } from "shared/lib/generateUUID"
import { RepeatUntilHandle, repeatUntil } from "shared/lib/repeatUntil"
import { useEvent } from "shared/lib/useEvent"
import { ExternalDimensioningResult } from "shared/types/__generated__/graphql"

export function useExternalDimensioningDataExchange() {
  const post: (
    externalDimensioningResult: ExternalDimensioningResult | null | undefined,
    options?: { freshID?: boolean }
  ) => RepeatUntilHandle<ExternalDimensioningResult> = useEvent(
    (externalDimensioningResult, options) => {
      function setupExchange() {
        return request(import.meta.env.VITE_DIM_EXCHANGE_URL, {
          method: "POST",
          body:
            externalDimensioningResult &&
            externalDimensioningResult.transactionId
              ? JSON.stringify(
                  stripTypename({
                    ...externalDimensioningResult,
                    transactionId: options?.freshID
                      ? generateUUID()
                      : externalDimensioningResult.transactionId,
                    transferData: { origin: "portal" }
                  })
                )
              : JSON.stringify({}),
          headers: {
            "Content-Type": "application/json"
          }
        }).then(resp => {
          return resp.json()
        })
      }
      return repeatUntil(
        () => setupExchange(),
        result => !!result,
        result => Promise.resolve(result),
        { timeout: 30_000, exponential: true, initialInterval: 200 }
      )
    }
  )

  return { post }
}
